<script setup lang="ts">
    import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import { HolidayPayObligation } from '@/types';
    import { usePermissions } from '@/composables/usePermissions';
    import Permission from '@/enums/Permission';
    import ContinueButton from '@/components/ContinueButton.vue';
    import HolidayPayObligationsTableExport from '@/components/holiday-pay-obligations/HolidayPayObligationsTableExport.vue';
    import { router } from '@inertiajs/vue3';

    const props = defineProps<{
        holidayPayObligation: HolidayPayObligation;
    }>();

    const { hasPermission } = usePermissions();

    const editHolidayPayObligation = () => {
        router.visit(
            route('v2.salary.holiday-pay-obligations.edit', {
                companyId: props.holidayPayObligation.company_id,
                id: props.holidayPayObligation.payroll_id,
            }),
        );
    };
</script>

<template>
    <DataTableActions :data="holidayPayObligation">
        <ContinueButton @click="editHolidayPayObligation">
            {{ $t('forms.open') }}
        </ContinueButton>
        <HolidayPayObligationsTableExport
            v-if="hasPermission(Permission.HOLIDAY_PAY_OBLIGATIONS_UPDATE)"
            :holiday-pay-obligation="holidayPayObligation"
        />
    </DataTableActions>
</template>
